import { ref } from 'vue';
import axios from '@/services/useAxios';

export default function () {
    const topic = ref(null);
    const topics = ref([]);

    const createTopic = async (data) => {
        const res = await axios.post('/notifications/topics', data);
        if (res.status === 201) {
            topic.value = res.data;
        } else {
            throw new Error(res.data.errors);
        }
    };

    const getTopic = async (id) => {
        const res = await axios.get(`/notifications/topics/${id}`);
        if (res.status === 200) {
            topic.value = res.data;
        } else {
            throw new Error(res.data.errors);
        }
    };

    const getTopics = async () => {
        const res = await axios.get('/notifications/topics');
        if (res.status === 200) {
            topics.value = res.data.items;
        } else {
            throw new Error(res.data.errors);
        }
    };

    const updateTopic = async (id, data) => {
        const res = await axios.put(`/notifications/topics/${id}`, data);
        if (res.status === 200) {
            topic.value = res.data;
        } else {
            throw new Error(res.data.errors);
        }
    };

    const deleteTopic = async (id) => {
        const res = await axios.delete(`/notifications/topics/${id}`);
        if (res.status === 200) {
            topic.value = res.data;
        } else {
            throw new Error(res.data.errors);
        }
    };

    return {
        topic,
        topics,
        createTopic,
        getTopic,
        getTopics,
        updateTopic,
        deleteTopic,
    };
}
